import { ReportsAndDocumentsLayout } from 'presentation/doctor/layouts/AddSurgicalOrderNew/ReportsEndDocuments'
import React from 'react'

const ReportsAndDocuments = () => {
  return <ReportsAndDocumentsLayout />
}

export default ReportsAndDocuments
